import { Box, Button, Typography, useTheme } from '@mui/material'
import styled from 'styled-components'

// ============== Page Container ==============
export const PageContainer = styled(Box).attrs(() => ({
  sx: {
    padding: { xs: '16px', sm: '20px', md: '24px' },
    maxWidth: '1000px',
    margin: '0 auto',
    overflowX: 'hidden',
  },
}))(() => ({}))

export const ContentContainer = styled(Box).attrs(() => ({
  sx: {
    flex: 1,
  },
}))(() => ({}))

// ============== Header ==============
export const HeaderContainer = styled(Box).attrs(() => ({
  sx: {
    display: 'flex',
    alignItems: 'center',
    gap: '12px',
    marginBottom: { xs: '16px', sm: '20px', md: '24px' },
  },
}))(() => ({}))

export const HeaderTitle = styled(Typography).attrs(() => {
  const theme = useTheme()
  return {
    variant: 'h4',
    sx: {
      flex: 1,
      fontSize: { xs: '22px', sm: '28px', md: '32px' },
      fontWeight: 700,
      color: theme.palette.grey[900],
      lineHeight: 1.3,
    },
  }
})(() => ({}))

export const HeaderBadgeContainer = styled(Box).attrs(() => ({
  sx: {
    display: 'flex',
    gap: '6px',
    alignItems: 'center',
    flexWrap: 'wrap',
  },
}))(() => ({}))

// ============== Meta Card ==============
export const MetaCardContainer = styled(Box).attrs(() => {
  const theme = useTheme()
  return {
    sx: {
      display: 'flex',
      gap: { xs: '12px', sm: '16px' },
      padding: { xs: '16px', sm: '20px' },
      backgroundColor: theme.palette.common.white,
      borderRadius: '12px',
      border: `1px solid ${theme.palette.grey[200]}`,
      marginBottom: { xs: '16px', sm: '20px', md: '24px' },
    },
  }
})(() => ({}))

export const MetaThumbnailContainer = styled(Box).attrs(() => ({
  sx: {
    flexShrink: 0,
    width: { xs: '100px', sm: '120px' },
    height: { xs: '100px', sm: '120px' },
    borderRadius: '8px',
    overflow: 'hidden',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
}))(() => ({}))

export const MetaPlaceholderTile = styled(Box).attrs(() => ({
  sx: {
    width: '100%',
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    background: 'linear-gradient(135deg, #FFF5ED 0%, #FFE8D4 100%)',
  },
}))(() => ({}))

export const MetaImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
`

export const MetaContentContainer = styled(Box).attrs(() => ({
  sx: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    gap: { xs: '8px', sm: '12px' },
  },
}))(() => ({}))

export const MetaRestaurantName = styled(Typography).attrs(() => {
  const theme = useTheme()
  return {
    variant: 'h6',
    sx: {
      fontSize: { xs: '16px', sm: '18px' },
      fontWeight: 700,
      color: theme.palette.grey[900],
      lineHeight: 1.4,
    },
  }
})(() => ({}))

export const MetaInfoRow = styled(Box).attrs(() => ({
  sx: {
    display: 'flex',
    gap: '8px',
    alignItems: 'center',
    flexWrap: 'wrap',
  },
}))(() => ({}))

export const MetaText = styled(Typography).attrs(() => {
  const theme = useTheme()
  return {
    variant: 'body2',
    sx: {
      fontSize: { xs: '13px', sm: '14px' },
      color: theme.palette.grey[600],
      lineHeight: 1.5,
    },
  }
})(() => ({}))

// ============== Dishes Section ==============
export const DishesSectionContainer = styled(Box).attrs(() => ({
  sx: {
    marginTop: { xs: '16px', sm: '20px', md: '24px' },
  },
}))(() => ({}))

export const DishesSectionHeader = styled(Box).attrs(() => ({
  sx: {
    marginBottom: { xs: '12px', sm: '16px' },
  },
}))(() => ({}))

export const DishesSectionTitle = styled(Typography).attrs(() => {
  const theme = useTheme()
  return {
    variant: 'h5',
    sx: {
      fontSize: { xs: '20px', sm: '22px', md: '24px' },
      fontWeight: 700,
      color: theme.palette.grey[900],
      marginBottom: '12px',
    },
  }
})(() => ({}))

export const SearchContainer = styled(Box).attrs(() => ({
  sx: {
    marginBottom: { xs: '16px', sm: '20px' },
  },
}))(() => ({}))

export const SearchInput = styled('input').attrs(() => {
  const theme = useTheme()
  return {
    type: 'text',
    placeholder: 'Search dishes...',
    style: {
      width: '100%',
      padding: '12px 16px',
      fontSize: '15px',
      borderRadius: '10px',
      border: `1px solid ${theme.palette.grey[300]}`,
      outline: 'none',
      fontFamily: 'inherit',
      backgroundColor: theme.palette.common.white,
      transition: 'border-color 0.2s ease',
    },
  }
})(() => ({}))

export const DishListContainer = styled(Box).attrs(() => ({
  sx: {
    display: 'flex',
    flexDirection: 'column',
    gap: 0,
    maxWidth: '650px',
    margin: '0 auto',
  },
}))(() => ({}))

export const DishCard = styled(Box).attrs(() => {
  const theme = useTheme()
  return {
    sx: {
      display: 'flex',
      flexDirection: 'column',
      gap: { xs: '6px', sm: '8px' },
      padding: { xs: '20px 0', sm: '24px 0', md: '26px 0' },
      width: '100%',
      borderBottom: `1px solid ${theme.palette.grey[200]}`,
      '&:last-child': {
        borderBottom: 'none',
      },
    },
  }
})(() => ({}))

export const DishName = styled(Typography).attrs(() => {
  const theme = useTheme()
  return {
    variant: 'h6',
    sx: {
      fontSize: { xs: '16px', sm: '17px', md: '18px' },
      fontWeight: 700,
      color: theme.palette.grey[900],
      lineHeight: 1.4,
      marginBottom: '2px',
    },
  }
})(() => ({}))

export const DishCategory = styled(Typography).attrs(() => {
  const theme = useTheme()
  return {
    variant: 'body2',
    sx: {
      fontSize: { xs: '13px', sm: '14px' },
      fontWeight: 400,
      color: theme.palette.grey[500],
      lineHeight: 1.4,
    },
  }
})(() => ({}))

export const DishPrice = styled(Typography).attrs(() => {
  const theme = useTheme()
  return {
    variant: 'body1',
    sx: {
      fontSize: { xs: '15px', sm: '16px' },
      fontWeight: 400,
      color: theme.palette.grey[500],
      marginTop: '4px',
    },
  }
})(() => ({}))

export const DishDescription = styled(Typography).attrs(() => {
  const theme = useTheme()
  return {
    variant: 'body2',
    sx: {
      fontSize: { xs: '14px', sm: '15px' },
      fontWeight: 400,
      color: theme.palette.grey[700],
      lineHeight: 1.5,
      marginTop: '6px',
    },
  }
})(() => ({}))

// ============== Empty States ==============
export const EmptyStateContainer = styled(Box).attrs(() => ({
  sx: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    padding: { xs: '48px 16px', sm: '64px 16px' },
    textAlign: 'center',
  },
}))(() => ({}))

export const EmptyStateText = styled(Typography).attrs(() => {
  const theme = useTheme()
  return {
    variant: 'body1',
    sx: {
      fontSize: { xs: '15px', sm: '16px' },
      color: theme.palette.grey[600],
      marginTop: '12px',
    },
  }
})(() => ({}))

// ============== Actions ==============
export const ActionsContainer = styled(Box).attrs(() => ({
  sx: {
    display: 'flex',
    flexDirection: 'column',
    gap: { xs: '16px', sm: '20px' },
    padding: { xs: '20px 0', sm: '24px 0' },
    marginTop: { xs: '24px', sm: '32px' },
    borderTop: '1px solid #e5e7eb',
  },
}))(() => ({}))

export const ActionButtonGroup = styled(Box).attrs(() => ({
  sx: {
    display: 'flex',
    gap: { xs: '12px', sm: '16px' },
    flexDirection: { xs: 'column', sm: 'row' },
  },
}))(() => ({}))

export const PrimaryActionButton = styled(Button).attrs(() => {
  const theme = useTheme()
  return {
    variant: 'contained',
    disableElevation: true,
    sx: {
      flex: 1,
      padding: { xs: '14px 20px', sm: '16px 24px' },
      backgroundColor: theme.palette.primary.main,
      color: 'white',
      border: 'none',
      borderRadius: '8px',
      fontSize: { xs: '15px', sm: '16px' },
      fontWeight: 600,
      textTransform: 'none',
      cursor: 'pointer',
      transition: 'background-color 0.2s ease',
      '&:hover': {
        backgroundColor: theme.palette.primary.dark,
      },
      '&:active': {
        backgroundColor: theme.palette.primary.dark,
      },
    },
  }
})(() => ({}))

export const SecondaryActionButton = styled(Button).attrs(() => ({
  variant: 'outlined',
  disableElevation: true,
  sx: {
    flex: 1,
    padding: { xs: '14px 20px', sm: '16px 24px' },
    backgroundColor: 'white',
    color: '#333',
    border: '1px solid #e5e7eb',
    borderRadius: '8px',
    fontSize: { xs: '15px', sm: '16px' },
    fontWeight: 600,
    textTransform: 'none',
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '8px',
    transition: 'all 0.2s ease',
    '&:hover': {
      backgroundColor: '#f9fafb',
      borderColor: '#d1d5db',
    },
    '&:active': {
      backgroundColor: '#f3f4f6',
    },
  },
}))(() => ({}))

export const DeleteActionText = styled(Button).attrs(() => {
  const theme = useTheme()
  return {
    sx: {
      padding: 0,
      background: 'none',
      border: 'none',
      cursor: 'pointer',
      fontSize: { xs: '14px', sm: '15px' },
      fontWeight: 500,
      color: theme.palette.error.main,
      textTransform: 'none',
      transition: 'color 0.2s ease',
      '&:hover': {
        color: theme.palette.error.dark,
      },
    },
  }
})(() => ({}))
